import { useDispatch, useSelector } from 'react-redux'
import { Translate, setLocale } from 'react-redux-i18n'
import { changeTypeFontSize } from '../../../../../app/slice'
import { store } from '../../../../../app/store'
import { Element } from '../../../../common/html/element'
import { getAllIdChecked } from '../../../../common/tree/helper'
import { changeLocaleDateTime } from '../../../../helpers/datetime'
import { saveLanguage } from '../../../../helpers/language'
import classes from '../../../index.module.scss'
import {
  selectForm,
  selectIcb,
  selectIcbTree,
  selectVsic,
  selectVsicTree,
} from '../../store/slice'
import { putUserSetting } from '../../store/thunk'

const SaveButton = ({ userSettings }) => {
  const dispatch = useDispatch()

  const vsicTree = useSelector(selectVsicTree)
  const icbTree = useSelector(selectIcbTree)
  const vsic = useSelector(selectVsic)
  const icb = useSelector(selectIcb)
  const form = useSelector(selectForm)

  const defaultLanguage = useSelector((state) => state.i18n.locale)

  const provinceId = form?.province
  const foreignId = form?.foreign

  const onSave = () => {
    //change Language
    const lang = userSettings.lang || defaultLanguage
    store.dispatch(setLocale(lang))
    saveLanguage(lang)
    changeLocaleDateTime(lang)

    //change Font Size
    const fontSize = userSettings.typeFontSize
    if (fontSize.length) {
      dispatch(changeTypeFontSize(fontSize))
    }

    //change Currency and Preferences
    const params = {
      vsicIds: getAllIdChecked(vsicTree, 'id', vsic),
      icbIds: getAllIdChecked(icbTree, 'id', icb),
      localLocationIds: provinceId,
      foreignLocationIds: foreignId,
      currencyCode: userSettings.currency,
      languageCodeEmail: userSettings.emailLang || defaultLanguage,
      languageCode: lang,
    }

    dispatch(
      putUserSetting({
        userSetting: params,
      }),
    )
  }
  return (
    <div className="dFlex justifyContentEnd" style={{ marginBottom: 6 }}>
      <Element
        elementName="button"
        style={{
          background: '#2c73e8',
          color: '#ffffff',
          border: '1px solid #D5D5D5',
        }}
        onClick={onSave}
        className={classes.saveButton}
      >
        <Translate value="settingPreferences.SAVE" />
      </Element>
    </div>
  )
}

export default SaveButton
